import { Component, ViewEncapsulation } from '@angular/core';
import { Nav, NavController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { MenuPage } from '../menu/menu';
import { PortfoliosPage } from '../portfolios/portfolios';
import { ListPage } from '../list/list';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { SettingPage } from '../setting/setting';
import { Storage } from '@ionic/storage';

import { ShariahServiceProvider } from '../../providers/shariah-service/shariah-service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  encapsulation: ViewEncapsulation.None,
})
export class HomePage {
  pages: Array<{ title: string; component: any }>;
  portfolios: Array<{ title: string; background: string }>;
  intro: string;
  user_id: any;

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    private storage: Storage,
    private shariahService: ShariahServiceProvider
  ) {
    this.intro = '';
    this.portfolios = [];

    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'Search', component: SearchPage },
      { title: 'My Portfolios', component: ListPage },
      { title: 'Shop', component: PortfoliosPage },
      { title: 'My Cart', component: CartPage },
      { title: 'Setting', component: SettingPage }
    ];
  }

  async ngOnInit() {
    this.user_id = await this.storage.get('user_id');

    await this.getPortfolio();
    await this.getIntro();
  }

  openPage(page) {
    this.navCtrl.push(page.component);
  }

  openLogin() {
    this.navCtrl.push(LoginPage);
  }

  logout() {
    this.storage.clear().then(() => {
      this.navCtrl.setRoot(LoginPage);
    });
  }

  openSlide(row) {
    this.navCtrl.push(MenuPage, {
      portfolio_title: row.title,
      portfolio_id: row.id,
      header_img: row.background
    });
  }

  async getIntro() {
    await this.shariahService.getHomeIntro().subscribe((data: any) => this.intro = data.text, err => console.log(err));
  }

  async getPortfolio() {
    await this.shariahService.getPortfolios().subscribe((data: any) => {
      let res = data.portfolio;
      for (let pfolio of res) {
        let temp = {
          id: pfolio.portfolio_id,
          title: pfolio.title,
          background: pfolio.feature_image,
          contentCount: pfolio.total_subportfolio
        };
        this.portfolios.push(temp);
      }
    }, err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts